import React, { useState } from "react";
import medicineicon from "../../assets/medicineicon2.svg";
import viewEyeIcon from "../../assets/eye.svg";
import { Tabs, Modal, Radio, Select } from "antd";
import packed from "../../assets/Tracking/packed.svg";
import YTP from "../../assets/Tracking/yettopack.svg";
import OFD from "../../assets/Tracking/outfordelivery.svg";
import Shipped from "../../assets/Tracking/Shipped.svg";
import Delivered from "../../assets/Tracking/Delivered.svg";
import {useNavigate } from "react-router-dom";
import { ClimbingBoxLoader } from "react-spinners";
import nodata from "../../assets/nodata.svg";
import OrderDetailsModal, {
  OrderDetailsSection,
  OrderDetailsTable,
  orderTableCellClass,
  orderTableHeadClass,
} from "../shared/OrderDetailsModal";


export default function PharmacyOrders({ orders }) {
   const [isModalVisible, setIsModalVisible] = useState(false);
   const [selectedOrder, setSelectedOrder] = useState(null);

      const navigate = useNavigate();
   const handleViewDetails = (order) => {
  setSelectedOrder(order);
  setIsModalVisible(true);

};

 console.log(orders,"selectedOrder")
  return (
    <div >
   
         <div className="flex items-center justify-between mb-4">
        
        <div className="flex items-center gap-2">
          <img src={medicineicon} alt="Medicine Icon" className="w-10 h-10" />
          <h2 className="text-lg font-semibold text-[#004276]">
           Pharmacy Orders <span className="bg-[#00BD7F] text-white font-medium px-2 py-1 rounded-md text-sm ml-1">{orders.length}</span>
        </h2>
        </div>
        <button className="text-[#00BD7F] text-sm font-semibold hover:underline -mt-2"
          onClick={() => navigate("/ClinicMedicineDetails")}>
          View All
        </button>
      </div>
<div className="bg-white rounded-lg shadow-[0px_4px_8px_rgba(0,0,0,0.15)] flex-1 flex flex-col" >
{orders.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-gray-500 py-8" style={{ height: '360px'}}>
            <img src={nodata} alt="No Data" className="w-48 h-48 mb-4" />
            <div>No Orders available for Today's Date</div>
          </div>
        ) : (
     <div style={{ height: '360px', overflowY: 'auto' }}>
       
           {orders.map((order) => {
             const drugList = order.drugPrescriptions?.drugs || [];
          if (drugList.length === 0) return null;

          return (
          <div
            key={order.id}
       className="flex items-center justify-between px-5 py-3 border-b last:border-none"
          >
            <div className="flex items-center gap-3">
              <div>
               <p className="font-semibold text-base text-[#1A1A1A] mb-1">
                 {order.patientName}
                </p>
                 {/* <p className="text-sm text-[#7D8592] mb-2">
                Order Id:{" "}
                <span className="font-semibold text-[#1A1A1A]">
                  {order.patientPrescriptionObjectId}
                </span>{" "}
                | Mobile:{" "}
                <span className="font-semibold text-[#1A1A1A]">
                  {order.patientMobileNo}
                </span>
              </p> */}
                <p className="text-sm text-[#7D8592] mb-0">
                  Order Id: <span className="font-semibold text-[#1A1A1A]">{order?.id}</span> | Phone No: <span className="font-semibold text-[#1A1A1A]"> {order.patientMobileNo}</span>
                </p>
              </div>
            </div>

            <div className="flex gap-3 items-center">
              {/* <span
                className={`px-3 py-1 text-xs font-medium rounded-full border ${
                  order.status === "Delivered"
                    ? " text-[#00BD7F] border-[#00BD7F]"
                    : " text-[#BD8F2C] border-[#BD8F2C]"
                }`}
              >
                Delivered
              </span> */}
              <button className="bg-white border-none outline-none p-2 rounded-full flex items-center justify-center">
                <img src={viewEyeIcon} alt="View" className="w-6 h-6" 
                 onClick={() => handleViewDetails(order)}
                />
              </button>
            </div>
          </div>
          )
       })}
      </div>
      
        )}
        </div>

{isModalVisible && selectedOrder && (
       <OrderDetailsModal
         open={isModalVisible}
         onClose={() => setIsModalVisible(false)}
         subtitle="Pharmacy Order Details"
         patientName={selectedOrder.patientName}
         status={selectedOrder.enquiryTickets?.[0]?.ticketStatus}
         address={selectedOrder.address}
         addressLabel="Delivery Address"
         infoFields={[
           {
             label: "Drug Order ID",
             value: selectedOrder.drugPrescriptions?.drugOrderId,
             mono: true,
           },
           {
             label: "Placed On",
             value: selectedOrder.createdDate?.split("T")[0],
           },
           { label: "Mobile No", value: selectedOrder.patientMobileNo },
         ]}
       >
         <OrderDetailsSection title="Medicine Details">
           <OrderDetailsTable>
             <thead>
               <tr>
                 <th className={`${orderTableHeadClass} text-left`}>Item Name</th>
                 <th className={`${orderTableHeadClass} text-center`}>Qty</th>
                 <th className={`${orderTableHeadClass} text-right`}>Unit Price</th>
                 <th className={`${orderTableHeadClass} text-right`}>Unit Price After Discount</th>
                 <th className={`${orderTableHeadClass} text-right`}>Total Amount</th>
               </tr>
             </thead>
             <tbody>
               {selectedOrder.drugPrescriptions?.drugs?.map((drug, index) => (
                 <tr key={index}>
                   <td className={orderTableCellClass}>{drug.drugName}</td>
                   <td className={`${orderTableCellClass} text-center`}>{drug.quantity}</td>
                   <td className={`${orderTableCellClass} text-right`}>₹{drug.rate}</td>
                   <td className={`${orderTableCellClass} text-right`}>₹{drug.discountedAmount || 0}</td>
                   <td className={`${orderTableCellClass} text-right`}>
                     ₹{(drug.discountedAmount * drug.quantity).toFixed(2)}
                   </td>
                 </tr>
               ))}
               <tr className="bg-[#F9FAFB]">
                 <td colSpan="4" className={`${orderTableCellClass} text-right font-bold`}>
                   Total Amount
                 </td>
                 <td className={`${orderTableCellClass} text-right font-bold text-[#00B77E]`}>
                   ₹
                   {selectedOrder.drugPrescriptions?.drugs
                     ?.reduce(
                       (acc, drug) => acc + drug.discountedAmount * drug.quantity,
                       0
                     )
                     .toFixed(2)}
                 </td>
               </tr>
             </tbody>
           </OrderDetailsTable>
         </OrderDetailsSection>
       </OrderDetailsModal>
                  )}
    </div>
  );
}
